import { create } from 'zustand';
import { orderTypes } from '../utils/orderUtils';
import { sendOrder, sendOrderASC } from '../channels/orderChannel';


function getOrder() {

    try {

        const saved = localStorage.getItem('order');

        return saved
            ? Number(saved)
            : 1;

    } catch {
        return 1;
    }

}

function saveOrder(order) {

    try {

        localStorage.setItem('order', order);
        
    } catch {}

}

function getOrderASC() {

    try {

        const saved = localStorage.getItem('orderASC');
        return saved !== null ? saved === 'true' : true;
       
    } catch {
        return true;
    }
    
}

function saveOrderASC(orderASC) {

    try {

        localStorage.setItem('orderASC', orderASC);
        
    } catch {}

}

const initialOrder = getOrder();

const initialOrderASC = getOrderASC();

export const useOrderStore = create((set, get) => ({

    orderTypes,
    order: initialOrder,
    orderASC: initialOrderASC,

    setOrder: (order, broadcast = true) => {
        
        set({ order });
        saveOrder(order);

        if (broadcast) {
            sendOrder(order);
        }

    },

    setOrderASC: (orderASC, broadcast = true) => {
        
        set({ orderASC });
        saveOrderASC(orderASC);

        if (broadcast) {
            sendOrderASC(orderASC);
        }

    },

    toggleOrderASC: () => {

        const orderASC = !get().orderASC;

        get().setOrderASC(orderASC);

    }

}));